<template>
  <div class="c-filter">
    <div class="c-contorl-btn"></div>
    <div class="c-form">
      <ElForm label-width="44" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="月份">
          <ElDatePicker v-model="datemonth" :picker-options="datetimeOption" type="month" placeholder="请选择" style="width: 100px" />
        </ElFormItem>
        <ElFormItem class="bg-transparent" label-width="0">
          <div class="operate-btns">
            <ElButton @click="$emit('on-down')">3D资产模板下载</ElButton>
            <Upload action="" :before-upload="preUpload" accept="application/vnd.ms-excel,.xls,.xlsx,.csv">
              <ElButton type="primary">导入3D资产</ElButton>
            </Upload>
            <ElButton type="primary" @click="down">数据导出</ElButton>
          </div>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { HOST_API } from '@/api/config'

export default {
  name: 'designerFilter',
  data() {
    return {
      datemonth: moment().subtract(1, 'months').format('YYYY-MM'),
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  methods: {
    sentEvent() {
      const month = moment(this.datemonth).format('YYYY-MM-DD')
      this.$emit('on-search', { month })
    },
    preUpload(file) {
      this.$emit('on-import', file)
      return false
    },
    down() {
      let url = `${HOST_API}/api/ptom/designer/exportDesignerInfo`
      url += `?sessionid=${this.$store.state.token}`
      url += `&month=${moment(this.datemonth).format('YYYY-MM-DD')}`
      window.open(url)
    }
  },
  watch: {
    datemonth(nVal) {
      nVal && this.sentEvent()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.operate-btns {
  button {
    margin-left: 5px;
  }
  display: flex;
  .ivu-upload-list {
    margin: 0;
  }
}
</style>
